import { Component,  Input , Output, EventEmitter} from '@angular/core';
import { StorageService } from '../../service/storage/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-userprofile',
  templateUrl: 'userprofile.component.html',
  styleUrls: ['./userprofile.component.scss']
})
export class UserprofileComponent {
  @Input()  token:any;
  @Output() tokenSet = new EventEmitter<any>();
  constructor(
    public storage: StorageService,
    private router: Router,
  ){

  }
  ngOnInit() {

  }
  signOut() {
    this.storage.removeStorage("user");
    this.token = false;
    this.tokenSet.emit(this.token);
    this.router.navigate(['home']);
  }

 }
